module.exports = __webpack_public_path__ + "static/media/appointment_slider_phone3.5d858b33.png";